export default __webpack_public_path__ + "static/media/logo-short.ba64dab3.png";